import 'intersection-observer/intersection-observer.js';
IntersectionObserver.prototype.POLL_INTERVAL = 100;

import Vue from 'vue';
import VueObserveVisibility from 'vue-observe-visibility';
import BBreakpoint from './b-breakpoints';
import DynamicImage from './components/DynamicImage.vue';
import VisibilityChangeAnnouncer from './visibility-change-announcer.js';
// import Inputmask from "inputmask";

Vue.use(VueObserveVisibility);
window.BBreakpoint = BBreakpoint;

// Bootstrap carousel doesn't work very well with the IntersectionObserver polyfill.
// Listen specifically for this event.
VisibilityChangeAnnouncer.registerEvent("slid.bs.carousel");

export const app = new Vue({
    el: '#app',
    components: { DynamicImage }
});

require('./app/global');
require('./app/events/create');
require('./app/events/dashboard');
require('./app/events/edit');
require('./app/events/scores_edit');
require('./app/events/round');
require('./app/events/widgets');
require('./app/plans');
require('./app/user');
require('./app/widget');

